import { useContext } from 'react';
import { TranslationContext } from '../context/TranslationContext';
import { Button } from './';

const ErrorModal = ({ message, onClose, page = 'CONFIG' }) => {
  const { t } = useContext(TranslationContext);
  
  if (!message) return null;
  
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl overflow-hidden max-w-md w-full">
        <div className="bg-red-600 px-4 py-2 text-white">
          <h3 className="text-lg font-medium">{t(page, 'ERROR_TITLE', 'Erreur')}</h3>
        </div>
        <div className="p-6">
          <p className="text-gray-700 mb-4">{message}</p>
          <div className="mt-4 flex justify-end">
            <Button
              type="button"
              variant="secondary"
              onClick={onClose}
            >
              {t(page, 'CLOSE', 'Fermer')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
